import { Box, Typography, useMediaQuery, useTheme } from '@mui/material';
import ArrowOutwardIcon from '@mui/icons-material/ArrowOutward';
import { NavLink } from '../../imports/generalImport';
import ProductCard from '../card/ProductCard';
import { v4 as uuidv4 } from "uuid";


const GiftSectionComponent = ({
  sectionTitle,
  sectionData,
  categoriesData,
}) => {
  const categoryIds = categoriesData?.flatMap((product) =>
    product?.node?.categories?.map((category) => category.id)
  ) || [];

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const link = (id) => ({
    pathname: '/card-list',
    search: `categoryIds[]=${id}`
  });

  const cards = (
    <>
      {(isMobile ? sectionData?.slice(0, 4) : sectionData?.slice(0, 5))?.map((item) => (
        <Box
          key={item?.id}
          sx={{
            flex: {
              sm: '0 0 32.3%',
              md: '0 0 32.55%',
              lg: '0 0 24.3%',
              xl: '0 0 19.28%',
            },
            minWidth: 0,
          }}
        >
          <ProductCard
          data={item} />
        </Box>
      ))}

      {
        (isMobile ? categoriesData?.slice(0, 4) : categoriesData?.slice(0, 5))?.map(
          (item) => (
            <Box
              key={item?.node?.id}
              sx={{
                flex: {
                  sm: '0 0 32.3%',
                  md: '0 0 32.55%',
                  lg: '0 0 24.3%',
                  xl: '0 0 19.28%',
                },
                minWidth: 0,
              }}
            >
              <ProductCard
              categories={item} />
            </Box>
          )
        )
      }
    </>
  );

  return (
    <Box sx={{ my: 4 }}>
      {sectionTitle && (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            mb: 0,
            mt: 4,
            px: 0.5,
            textTransform: 'capitalize',
            color: '#002865',
          }}
        >
          <Typography
            sx={{
              fontSize: { xs: '16px', sm: '24px', md: '30px' },
              fontWeight: 600,
              fontFamily: 'Be Vietnam Pro',
            }}
          >
            {sectionTitle}
          </Typography>
          {!['Top picks', 'Most selling'].includes(sectionTitle) && (
            <Typography
              component={NavLink}
              to={link(categoryIds)}
              sx={{
                fontSize: { xs: '12px', sm: '16px' },
                color: '#000',
                fontWeight: 500,
                textDecoration: 'none',
                display: 'flex',
                alignItems: 'center',
                '& svg': {
                  fontSize: { xs: '13px', sm: '16px' },
                  ml: 0.5,
                  transition: '0.3s',
                },
                '&:hover svg': {
                  transform: 'translate(3px, -3px)',
                },
              }}
            >
              View All <ArrowOutwardIcon />
            </Typography>
          )}
        </Box>
      )}

      {isMobile ? (
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
            gap: 1,
          }}
        >
          {(sectionData?.slice(0, 4) || [])?.map((item) => (
            <ProductCard key={item?.id} data={item} />
          ))}

          {(categoriesData?.slice(0, 4) || [])?.map((item) => (
            <ProductCard key={item?.node?.id} categories={item} />
          ))}
        </Box>
      ) : (
        <Box
          sx={{
            display: 'flex',
            flexWrap: 'nowrap',
            gap: 2,
          }}
        >
          {cards}
        </Box>
      )}
    </Box>
  );
};

export default GiftSectionComponent;
